import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ChatService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chat-window',
  templateUrl: './chat-window.component.html',
  styleUrls: ['./chat-window.component.scss'],
})
export class ChatWindowComponent implements OnInit {
  success;
  error;
  pending;
  conversationsData: any[] = [];
  organizationId: any;
  fullScreenMode: boolean = false;
  imageSrc = {
    name: 'open',
    src: 'assets/icons/closeChat.svg',
  };
  private eventSubscription: Subscription;
  constructor(
    private location: Location,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.fullScreenMode = false;
    this.eventSubscription = this.chatService
      .getFullScreenEvent()
      .subscribe((event) => {
        this.fullScreenMode = event;
        console.log(event);
        // this.cdr.detectChanges();
      });
  }
  type = 'CLOSE';
  ngOnInit(): void {
    // this.getOrganizationMessages({});
  }
  goBack() {
    this.location.back();
  }
  getOrganizationMessages(params: any) {
    this.pending = true;

    this.chatService
      .getAllOrganizationChatSessions({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.conversationsData = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
}
